import React from 'react';
import './ToggleSwitch.css';

interface ToggleSwitchProps {
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
	ariaLabel?: string;
	settingId?: string;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
	checked,
	onChange,
	disabled = false,
	ariaLabel,
	settingId,
}) => {
	const handleToggleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (!disabled) {
			onChange(event.target.checked);
		}
	};

	return (
		<label className={`toggle-switch ${disabled ? 'toggle-disabled' : ''}`}>
			<input
				type="checkbox"
				id={settingId}
				checked={checked}
				onChange={handleToggleChange}
				disabled={disabled}
				aria-label={ariaLabel}
			/>
			<span className="toggle-slider"></span>
		</label>
	);
};
